import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, throwError as observableThrowError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class VehicleLookupService extends BaseApiService {
    private lookups: any;

    getLookUpData() {
        const self = this;
        const lookups$: Subject<any> = new Subject<any>();

        if (this.lookups) {
            const newResult$: BehaviorSubject<any> = new BehaviorSubject<any>(this.lookups);
            newResult$.next(this.lookups);
            return newResult$;
        } else {
            this.get('Vehicle/Vehicle/GetLookups').pipe(first()).subscribe(
                r => {
                    self.lookups = r;
                    lookups$.next(r);
                },
                e => {
                    console.log(e);
                }
            );
        }

        return lookups$;
    }

    getVehicleIdentificationTypes() {
        return this.get('Vehicle/Vehicle/GetVehicleIdentificationTypes').pipe(
            catchError(
                (error) => this.handleError(error)
            ));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }
}
